import * as Yup from 'yup';

const PersonalDataSchema = Yup.object().shape({
    nombre: Yup.string().required('Completá el Nombre para continuar').matches(/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+\s*$/, "Ingresá un nombre válido"),
    apellido: Yup.string().required('Completá el Apellido para continuar').matches(/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+\s*$/, "Ingresá un apellido válido"),
    numeroDocumento: Yup.string()
        .required('Completá el Número de Documento para continuar')
        .test({
            name: 'numeroDocumento',
            message: 'El número de DNI que ingresaste no es válido',
            test: function (value) {
                if (!value) {
                    return false;
                } else {
                    let myRe = /^[\d]{1,3}\.?[\d]{3,3}\.?[\d]{3,3}$/;
                    return myRe.test(value);
                }
            },
        }),
    telefonoCelular: Yup.string()
        .matches(/^[0-9]{6,}$/, 'Ingresá un telefono celular correcto.')
        .min(8, 'Ingresá al menos ${min} números')
        .max(20, 'Ingresá hasta ${max} números')
        .nullable()
        .required('Completa el teléfono para continuar'),
    terminos: Yup.boolean().isTrue("Aceptá los términos y condiciones para continuar"),
    // tipoDeDocumento: Yup.string()
    //     .required('Seleccioná una opción')
});

export default PersonalDataSchema;
